import Refinement from 'cio/app-models/conditions/refinement';
import { ever, recent } from 'cio/app-models/conditions/refinement';
import { SECONDS_IN_DAY } from 'cio/utils/constants';

export default function (times: number, within: number) {
  let period = within === 0 ? ever : recent;

  // No refinement for the common case: once ever
  if (times === 1 && period === ever) {
    return null;
  }

  let days = Math.floor(within / SECONDS_IN_DAY);
  days = Math.max(days, 1);

  return Refinement.create({ period, days, times });
}
